import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import Header from "../../components/headers/MainHeader";
import Footer from "../../components/footers/MainFooterWithLinks";
import DressRoom from "../../images/img/Zameru.svg";
import UsaMap from "../../images/icon/usa.svg";
import TurkeyMap from "../../images/icon/TurkeyMap.svg";
import {SectionSteps} from "../../components/misc/Headings";
import AnimationRevealPage from "../../components/helpers/AnimationRevealPage";
import { useTranslation, Trans } from "react-i18next";
const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-12 lg:py-16`;
const ImageWrapper = tw.div`flex justify-center items-center flex-col md:flex-row`;
const InfoColumn = tw.div`text-center xl:text-left max-w-lg xl:max-w-none mx-auto xl:mx-0`;



const HighlightedText = styled.span`
    ${tw`  text-base xl:text-lg  text-gray-700`}

`;

const MapTitle =  tw(
    SectionSteps
)` font-extrabold text-3xl sm:text-3xl  lg:text-3xl text-center leading-tight`;

const TableTitle =  tw(
    SectionSteps
)` font-extrabold text-3xl sm:text-3xl   lg:text-3xl text-center mb-4 mt-6 leading-tight `;


const TableWrapper = styled.div`
    ${tw`overflow-x-auto`}
`;

const StyledTable = styled.table`
    ${tw`w-full text-sm md:text-base border-collapse`}
    border: 2px solid #ccc;
    text-align: center;
    vertical-align: middle;
    th, td {
        ${tw`border border-gray-400 px-4 py-2`}
    }
    th {
        ${tw`bg-gray-100`}
    }
`;

const InfoText = styled.p`
    ${tw` mt-4 text-base xl:text-lg my-2 lg:my-4 text-gray-700`}
    font-size: 22px;
    line-height: 32px;

    font-weight: normal;
`;

export default () => {
    const { t } = useTranslation();
    return (
        <>
            <AnimationRevealPage>
                <Header
                    heading={t("clothesSizes.header.title")}
                    paragraph={t("clothesSizes.header.paragraph")}
                    imageSrc={DressRoom}
                    roundedHeaderButton={false}
                />

                <Container>
                    <Content>
                        <InfoColumn>
                            <InfoText>
                                <HighlightedText>{t("clothesSizes.tips.1.title")}</HighlightedText> {t("clothesSizes.tips.1.text")}<br/><br/>
                                <HighlightedText>{t("clothesSizes.tips.2.title")}</HighlightedText> {t("clothesSizes.tips.2.text")}<br/><br/>
                                <HighlightedText>{t("clothesSizes.tips.3.title")}</HighlightedText> {t("clothesSizes.tips.3.text")}<br/><br/>
                                <HighlightedText>{t("clothesSizes.tips.4.title")}</HighlightedText> {t("clothesSizes.tips.4.text")}<br/><br/>
                                <HighlightedText>{t("clothesSizes.tips.5.title")}</HighlightedText> {t("clothesSizes.tips.5.text")}
                                <ImageWrapper>
                                    <MapTitle>{t("clothesSizes.us.mapTitle")}</MapTitle>
                                    <img src={UsaMap} alt={t("clothesSizes.us.mapAlt")} style={{ maxWidth: '100%', height: 'auto', marginLeft: '20px' }} />
                                </ImageWrapper>

                                {t("clothesSizes.us.diff")}
                                <Trans
                                    i18nKey="clothesSizes.us.system"
                                    components={{ h: <HighlightedText/> }}
                                />
                                <Trans
                                    i18nKey="clothesSizes.us.determine"
                                    components={{ h: <HighlightedText/> }}
                                />
                            </InfoText>
                        </InfoColumn>
                        <InfoColumn>
                            <TableTitle>{t("sizeTables.us.women.title")}</TableTitle>
                            <TableWrapper>
                                <StyledTable>
                                    <thead>
                                    <tr>
                                        <td>{t("sizeTables.us.women.th.kz")}</td>
                                        <td>{t("sizeTables.us.women.th.intl")}</td>
                                        <td>{t("sizeTables.us.women.th.bust")}</td>
                                        <td>{t("sizeTables.us.women.th.waist")}</td>
                                        <td>{t("sizeTables.us.women.th.hips")}</td>
                                        <td>{t("sizeTables.us.women.th.sleeve")}</td>
                                        <td>{t("sizeTables.us.women.th.us")}</td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>38</td>
                                        <td>XXS</td>
                                        <td>76</td>
                                        <td>58</td>
                                        <td>82</td>
                                        <td>58/60</td>
                                        <td>0</td>
                                    </tr>
                                    <tr>
                                        <td>40</td>
                                        <td>XS</td>
                                        <td>80</td>
                                        <td>62</td>
                                        <td>86</td>
                                        <td>59/61</td>
                                        <td>2</td>
                                    </tr>
                                    <tr>
                                        <td>42</td>
                                        <td>S</td>
                                        <td>84</td>
                                        <td>66</td>
                                        <td>92</td>
                                        <td>59/61</td>
                                        <td>4</td>
                                    </tr>
                                    <tr>
                                        <td>44</td>
                                        <td>M</td>
                                        <td>88</td>
                                        <td>70</td>
                                        <td>96</td>
                                        <td>60/62</td>
                                        <td>6</td>
                                    </tr>
                                    <tr>
                                        <td>46</td>
                                        <td>M</td>
                                        <td>92</td>
                                        <td>74</td>
                                        <td>100</td>
                                        <td>60/62</td>
                                        <td>8</td>
                                    </tr>
                                    <tr>
                                        <td>48</td>
                                        <td>L</td>
                                        <td>96</td>
                                        <td>78</td>
                                        <td>104</td>
                                        <td>60/62</td>
                                        <td>10</td>
                                    </tr>
                                    <tr>
                                        <td>50</td>
                                        <td>L</td>
                                        <td>100</td>
                                        <td>82</td>
                                        <td>108</td>
                                        <td>61/63</td>
                                        <td>12</td>
                                    </tr>
                                    <tr>
                                        <td>52</td>
                                        <td>XL</td>
                                        <td>104</td>
                                        <td>86</td>
                                        <td>112</td>
                                        <td>61/63</td>
                                        <td>14</td>
                                    </tr>
                                    <tr>
                                        <td>54</td>
                                        <td>XXL</td>
                                        <td>108</td>
                                        <td>90</td>
                                        <td>116</td>
                                        <td>61/63</td>
                                        <td>16</td>
                                    </tr>
                                    <tr>
                                        <td>56</td>
                                        <td>XXL</td>
                                        <td>112</td>
                                        <td>94</td>
                                        <td>120</td>
                                        <td>61/63</td>
                                        <td>18</td>
                                    </tr>
                                    <tr>
                                        <td>58</td>
                                        <td>XXXL</td>
                                        <td>116</td>
                                        <td>98</td>
                                        <td>124</td>
                                        <td>62/64</td>
                                        <td>20</td>
                                    </tr>
                                    <tr>
                                        <td>60</td>
                                        <td>4XL</td>
                                        <td>120</td>
                                        <td>100</td>
                                        <td>128</td>
                                        <td>62/64</td>
                                        <td>22</td>
                                    </tr>
                                    <tr>
                                        <td>62</td>
                                        <td>4XL</td>
                                        <td>124</td>
                                        <td>104</td>
                                        <td>132</td>
                                        <td>62,5/65</td>
                                        <td>24</td>
                                    </tr>
                                    <tr>
                                        <td>64</td>
                                        <td>4XL</td>
                                        <td>128</td>
                                        <td>108</td>
                                        <td>136</td>
                                        <td>62,5/65</td>
                                        <td>26</td>
                                    </tr>
                                    </tbody>
                                </StyledTable>
                            </TableWrapper>
                        </InfoColumn>
                        <InfoColumn>
                            <TableTitle>{t("sizeTables.us.men.title")}</TableTitle>                            <TableWrapper>
                                <StyledTable>
                                    <thead>
                                    <tr>
                                        <td>{t("sizeTables.us.men.th.kz")}</td>
                                        <td>{t("sizeTables.us.men.th.intl")}</td>
                                        <td>{t("sizeTables.us.men.th.chest")}</td>
                                        <td>{t("sizeTables.us.men.th.waist")}</td>
                                        <td>{t("sizeTables.us.men.th.hips")}</td>
                                        <td>{t("sizeTables.us.men.th.sleeve")}</td>
                                        <td>{t("sizeTables.us.men.th.us")}</td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>44</td>
                                        <td>XS</td>
                                        <td>88</td>
                                        <td>70</td>
                                        <td>92</td>
                                        <td>59</td>
                                        <td>4</td>
                                    </tr>
                                    <tr>
                                        <td>46</td>
                                        <td>S</td>
                                        <td>92</td>
                                        <td>76</td>
                                        <td>96</td>
                                        <td>60</td>
                                        <td>6</td>
                                    </tr>
                                    <tr>
                                        <td>48</td>
                                        <td>M</td>
                                        <td>96</td>
                                        <td>82</td>
                                        <td>100</td>
                                        <td>61</td>
                                        <td>8</td>
                                    </tr>
                                    <tr>
                                        <td>50</td>
                                        <td>L</td>
                                        <td>100</td>
                                        <td>88</td>
                                        <td>104</td>
                                        <td>62</td>
                                        <td>10</td>
                                    </tr>
                                    <tr>
                                        <td>52</td>
                                        <td>L / XL</td>
                                        <td>104</td>
                                        <td>94</td>
                                        <td>108</td>
                                        <td>63</td>
                                        <td>12</td>
                                    </tr>
                                    <tr>
                                        <td>54</td>
                                        <td>XL</td>
                                        <td>108</td>
                                        <td>100</td>
                                        <td>112</td>
                                        <td>63</td>
                                        <td>14</td>
                                    </tr>
                                    <tr>
                                        <td>56</td>
                                        <td>XXL</td>
                                        <td>112</td>
                                        <td>106</td>
                                        <td>116</td>
                                        <td>64</td>
                                        <td>16</td>
                                    </tr>
                                    <tr>
                                        <td>58</td>
                                        <td>XXL</td>
                                        <td>116</td>
                                        <td>112</td>
                                        <td>120</td>
                                        <td>64</td>
                                        <td>18</td>
                                    </tr>
                                    <tr>
                                        <td>60</td>
                                        <td>XXXL</td>
                                        <td>120</td>
                                        <td>118</td>
                                        <td>124</td>
                                        <td>65</td>
                                        <td>20</td>
                                    </tr>
                                    <tr>
                                        <td>62</td>
                                        <td>XXXL</td>
                                        <td>124</td>
                                        <td>120</td>
                                        <td>128</td>
                                        <td>65</td>
                                        <td>22</td>
                                    </tr>
                                    <tr>
                                        <td>64</td>
                                        <td>4XL</td>
                                        <td>128</td>
                                        <td>124</td>
                                        <td>132</td>
                                        <td>66</td>
                                        <td>24</td>
                                    </tr>
                                    </tbody>
                                </StyledTable>
                            </TableWrapper>
                            <InfoText>
                                <strong>{t("sizeTables.us.shoes.introTitle")}</strong><br/><br/>
                                {t("sizeTables.us.shoes.introText")}
                            </InfoText>
                        </InfoColumn>
                        <InfoColumn>
                            <InfoText>
                                <TableTitle>{t("sizeTables.us.shoes.women.title")}</TableTitle>
                                <TableWrapper>
                                    <StyledTable>
                                        <thead>
                                        <tr>
                                            <td>{t("sizeTables.us.shoes.th.footCm")}</td>>
                                            <td>22</td>
                                            <td>22.5</td>
                                            <td>23</td>
                                            <td>23.5</td>
                                            <td>24</td>
                                            <td>24.5</td>
                                            <td>25</td>
                                            <td>25.5</td>
                                            <td>26</td>
                                            <td>26.5</td>
                                            <td>27</td>
                                            <td>27.5</td>
                                            <td>28</td>
                                            <td>28.5</td>
                                            <td>29</td>
                                        </tr>
                                        <tr>
                                            <td>{t("sizeTables.us.shoes.th.footIn")}</td>
                                            <td>8.7</td>
                                            <td>8.9</td>
                                            <td>9.1</td>
                                            <td>9.3</td>
                                            <td>9.4</td>
                                            <td>9.6</td>
                                            <td>9.8</td>
                                            <td>10.0</td>
                                            <td>10.2</td>
                                            <td>10.4</td>
                                            <td>10.6</td>
                                            <td>10.8</td>
                                            <td>11</td>
                                            <td>11.2</td>
                                            <td>11.4</td>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td>{t("sizeTables.us.shoes.th.kz")}</td>
                                            <td>35</td>
                                            <td>35.5</td>
                                            <td>36</td>
                                            <td>36.5</td>
                                            <td>37</td>
                                            <td>37.5</td>
                                            <td>38</td>
                                            <td>38.5</td>
                                            <td>39</td>
                                            <td>39.5</td>
                                            <td>40</td>
                                            <td>40.5</td>
                                            <td>41</td>
                                            <td>41.5</td>
                                            <td>42</td>
                                        </tr>
                                        <tr>
                                            <td>{t("sizeTables.us.shoes.th.us")}</td>
                                            <td>5</td>
                                            <td>5.5</td>
                                            <td>6</td>
                                            <td>6.5</td>
                                            <td>7</td>
                                            <td>7.5</td>
                                            <td>8</td>
                                            <td>8.5</td>
                                            <td>9</td>
                                            <td>9.5</td>
                                            <td>10</td>
                                            <td>10.5</td>
                                            <td>11</td>
                                            <td>11.5</td>
                                            <td>12</td>
                                        </tr>
                                        </tbody>
                                    </StyledTable>
                                </TableWrapper>
                                <TableTitle>{t("sizeTables.us.shoes.men.title")}</TableTitle>
                                <TableWrapper>
                                    <StyledTable>
                                        <thead>
                                        <tr>
                                            <td>{t("sizeTables.us.shoes.th.footCm")}</td>

                                            <td>23.5</td>
                                            <td>24</td>
                                            <td>24.5</td>
                                            <td>25</td>
                                            <td>25.5</td>
                                            <td>26</td>
                                            <td>26.5</td>
                                            <td>27</td>
                                            <td>27.5</td>
                                            <td>28</td>
                                            <td>28.5</td>
                                            <td>29</td>
                                            <td>29.5</td>
                                            <td>30</td>
                                            <td>30.5</td>
                                            <td>31</td>
                                            <td>31.5</td>
                                        </tr>
                                        <tr>
                                            <td>{t("sizeTables.us.shoes.th.footIn")}</td>
                                            <td>9.3</td>
                                            <td>9.4</td>
                                            <td>9.6</td>
                                            <td>9.8</td>
                                            <td>10.0</td>
                                            <td>10.2</td>
                                            <td>10.4</td>
                                            <td>10.6</td>
                                            <td>10.8</td>
                                            <td>11.0</td>
                                            <td>11.2</td>
                                            <td>11.4</td>
                                            <td>11.6</td>
                                            <td>11.8</td>
                                            <td>12.0</td>
                                            <td>12.2</td>
                                            <td>12.4</td>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td>{t("sizeTables.us.shoes.th.kz")}</td>
                                            <td>36.5</td>
                                            <td>37</td>
                                            <td>37.5</td>
                                            <td>38</td>
                                            <td>39</td>
                                            <td>40</td>
                                            <td>40.5</td>
                                            <td>41</td>
                                            <td>42</td>
                                            <td>43</td>
                                            <td>43.5</td>
                                            <td>44</td>
                                            <td>44.5</td>
                                            <td>45</td>
                                            <td>45.5</td>
                                            <td>46</td>
                                            <td>46.5</td>
                                        </tr>
                                        <tr>
                                            <td>{t("sizeTables.us.shoes.th.us")}</td>
                                            <td>5.5</td>
                                            <td>6</td>
                                            <td>6.5</td>
                                            <td>7</td>
                                            <td>7.5</td>
                                            <td>8</td>
                                            <td>8.5</td>
                                            <td>9</td>
                                            <td>9.5</td>
                                            <td>10</td>
                                            <td>10.5</td>
                                            <td>11</td>
                                            <td>11.5</td>
                                            <td>12</td>
                                            <td>12.5</td>
                                            <td>13</td>
                                            <td>13.5</td>
                                        </tr>
                                        </tbody>
                                    </StyledTable>
                                </TableWrapper>


                                {t("clothesSizes.conclusion.notice")}>
                                {t("clothesSizes.conclusion.recommendations")}
                            </InfoText>
                        </InfoColumn>
                    </Content>
                </Container>
                <Footer />
            </AnimationRevealPage>
        </>
    );
};
